"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_INVALID_EMAIL_ADDRESS = exports.SITE_USER_NOT_FOUND = void 0;
var SITE_USER_NOT_FOUND = 4;
exports.SITE_USER_NOT_FOUND = SITE_USER_NOT_FOUND;
var USER_INVALID_EMAIL_ADDRESS = 10011;
exports.USER_INVALID_EMAIL_ADDRESS = USER_INVALID_EMAIL_ADDRESS;
//# sourceMappingURL=ErrorCodes.js.map